module.exports = __webpack_public_path__ + "img/2.ac6c60fd.jpg";